export default "/static/dashboard/build/app/img/v2/48b526b25b45a3b93f586043a37d3e59.png";